"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Name = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column'
});
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  overflow: 'hidden',
  textAlign: 'left',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  width: '100%'
});
